<my-portal-restricted-area-reserve></my-portal-restricted-area-reserve>
<my-portal-restricted-area-payment></my-portal-restricted-area-payment>
